import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg, fmtDate } from "../lib/api";
import { PageHeader, Empty } from "../components/common";
import { VarChips } from "../components/CampaignForms";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Textarea } from "../components/ui/textarea";
import { Plus, Trash2 } from "lucide-react";

const BLANK = { name: "Nouveau modèle", subject: "", body: "Hi {first_name},\n\n", followup_body: "" };

export default function Templates() {
  const [items, setItems] = useState([]);
  const [cur, setCur] = useState(null);
  const [preview, setPreview] = useState(null);
  const load = () => api.get("/templates").then((r) => { setItems(r.data); return r.data; });
  useEffect(() => { load().then((d) => d[0] && setCur(d[0])); }, []);
  useEffect(() => {
    if (!cur) return;
    const t = setTimeout(() => api.post("/templates/preview", { subject: cur.subject, body: cur.body }).then((r) => setPreview(r.data)), 300);
    return () => clearTimeout(t);
  }, [cur]);
  const save = async () => {
    try {
      const r = cur.id ? await api.put(`/templates/${cur.id}`, cur) : await api.post("/templates", cur);
      toast.success("Modèle enregistré");
      setCur(r.data); load();
    } catch (e) { toast.error(errMsg(e)); }
  };
  const del = async () => {
    if (!cur.id || !window.confirm("Supprimer ce modèle ?")) return;
    await api.delete(`/templates/${cur.id}`);
    const d = await load(); setCur(d[0] || null);
  };
  return (
    <div>
      <PageHeader eyebrow="Rédaction" title="Modèles d'email" description="Variables disponibles : {first_name}, {last_name}, {company_name}, {job_title}, {industry} et {personalization} (phrase IA validée)."
        actions={<Button onClick={() => setCur({ ...BLANK })} data-testid="new-template-btn"><Plus className="h-4 w-4 mr-1" />Nouveau modèle</Button>} />
      <div className="grid lg:grid-cols-[240px_1fr_1fr] gap-6">
        <div className="space-y-1" data-testid="templates-list">
          {items.map((t) => (
            <button key={t.id} onClick={() => setCur(t)} className={`w-full text-left px-3 py-2.5 rounded-md text-sm ${cur?.id === t.id ? "bg-slate-100 text-[#0b1f3a] font-medium" : "text-slate-600 hover:bg-slate-50"}`} data-testid={`template-item-${t.id}`}>
              {t.name}<div className="text-[11px] text-slate-400 font-normal">{fmtDate(t.updated_at)}</div>
            </button>
          ))}
        </div>
        {!cur ? <Empty title="Aucun modèle" /> : (
          <>
            <div className="space-y-4">
              <div className="space-y-1"><Label className="text-xs">Nom du modèle</Label><Input value={cur.name} onChange={(e) => setCur({ ...cur, name: e.target.value })} data-testid="template-name" /></div>
              <div className="space-y-1"><Label className="text-xs">Objet</Label><Input value={cur.subject} onChange={(e) => setCur({ ...cur, subject: e.target.value })} data-testid="template-subject" /></div>
              <div className="space-y-1"><Label className="text-xs">Corps</Label><Textarea rows={16} className="font-mono text-[12.5px]" value={cur.body} onChange={(e) => setCur({ ...cur, body: e.target.value })} data-testid="template-body" /></div>
              <VarChips onInsert={(v) => setCur({ ...cur, body: cur.body + v })} />
              <div className="space-y-1"><Label className="text-xs">Texte de relance</Label><Textarea rows={7} className="font-mono text-[12.5px]" value={cur.followup_body || ""} onChange={(e) => setCur({ ...cur, followup_body: e.target.value })} data-testid="template-followup" /></div>
              <div className="flex gap-2"><Button onClick={save} data-testid="template-save">Enregistrer</Button>{cur.id && <Button variant="ghost" onClick={del} data-testid="template-delete"><Trash2 className="h-4 w-4" /></Button>}</div>
            </div>
            <div>
              <div className="eyebrow mb-3">Aperçu (contact exemple)</div>
              {preview && (
                <div className="border border-slate-200 rounded-md" data-testid="template-preview">
                  <div className="px-5 py-3 border-b border-slate-200 text-sm"><span className="text-slate-400 mr-2">Objet</span>{preview.subject}</div>
                  <div className="px-5 py-5 email-preview text-sm" dangerouslySetInnerHTML={{ __html: preview.html }} />
                </div>
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
}
